import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';

const AndroidBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isAndroid, setIsAndroid] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const { t, language } = useLanguage();

  useEffect(() => {
    // Detect Android device
    const userAgent = navigator.userAgent.toLowerCase();
    const isAndroidDevice = /android/.test(userAgent);
    setIsAndroid(isAndroidDevice);

    // Detect mobile device
    const checkMobile = () => {
      const mobile = window.innerWidth <= 800; // Same breakpoint as your CSS
      setIsMobile(mobile);
    };

    // Check on mount
    checkMobile();

    // Check on resize
    window.addEventListener('resize', checkMobile);

    // Check if app is already installed (basic check)
    const isAppInstalled = localStorage.getItem('colquest-app-installed');
    
    if (isAndroidDevice && !isAppInstalled) {
      // Show banner after a short delay
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 2000);
      
      return () => {
        clearTimeout(timer);
        window.removeEventListener('resize', checkMobile);
      };
    }

    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  const handleDownload = () => {
    // Open Play Store
    window.open('https://play.google.com/store/apps/details?id=com.colquest.app', '_blank');
    
    // Mark as shown for this session
    localStorage.setItem('colquest-banner-shown', 'true');
    setIsVisible(false);
  };

  const handleClose = () => {
    setIsVisible(false);
    // Mark as shown for this session
    localStorage.setItem('colquest-banner-shown', 'true');
  };

  const handleInstall = () => {
    // Mark app as installed
    localStorage.setItem('colquest-app-installed', 'true');
    setIsVisible(false);
  };

  // Only show if Android AND mobile AND not installed
  if (!isAndroid || !isMobile || !isVisible) {
    return null;
  }

  return (
    <div className="android-banner">
      <div className="android-banner-content">
        <div className="android-banner-icon">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
            <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.61 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
          </svg>
        </div>
        <div className="android-banner-text">
          <h3>{t('android_banner.title') || 'Download ColQuest'}</h3>
          <p>{t('android_banner.subtitle') || 'Get the app on Google Play'}</p>
        </div>
        <div className="android-banner-actions">
          <button onClick={handleDownload} className="android-banner-download">
            {t('android_banner.download') || 'Download'}
          </button>
          <button onClick={handleInstall} className="android-banner-install">
            {t('android_banner.install') || 'I have it'}
          </button>
        </div>
        <button onClick={handleClose} className="android-banner-close" aria-label={typeof t('android_banner.close_aria') === 'string' ? t('android_banner.close_aria') as string : 'Close banner'}>
          ×
        </button>
      </div>
    </div>
  );
};

export default AndroidBanner; 